import React from "react";
import { useHistory } from "react-router-dom";
import { NavLink } from "react-router-dom";  // Corrected this import
import { postLogin } from "../Component/ClubLoginComponent/Login";
import axios from "axios";
const PayConfirmed = () => {
  let history = useHistory();
  const { state } = history.location;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (state?.regDetails) {
      const { email, psw_2 } = state.regDetails;

      postLogin(
        {
          email,
          password: psw_2,
        },
        true
      );
    } else {
      history.push("/loged-user-home");
    }
  };
  const handleInvoiceDownload = async () => {
    const stripeTransactionId = localStorage.getItem("stripe_payment_method_id");
  
    if (!stripeTransactionId) {
      console.error("Stripe Transaction ID is missing");
      return;
    }
  
    try {
      const response = await axios.get(
        `https://timelygolf.co.uk/club/txns/invoice/download/${stripeTransactionId}`
      );
  
      if (response?.data?.status === "SUCCESS") {
        const invoiceUrl = response.data.data;
        // Open the PDF in a new tab
        window.open(invoiceUrl, "_blank");
      } else {
        console.error("Failed to get invoice URL:", response?.data);
      }
    } catch (error) {
      console.error("Error fetching invoice URL:", error);
    }
  };
  
  return (
    <section className="section-p club_Login">
      <div className="page-width">
        <div className="new_paid-block">
          <h1 className="new_paid-title text-jost-sb-50">
            Thank you for registering with Timely Golf{" "}
          </h1>

          <div className="new_paid__wrap_block">
            <div className="progress_bar">
              <ul className="progress_bar__row">
                <li className="text-jost-sb-22 completed">CLUB Details</li>
                <li className="text-jost-sb-22 completed">Golf Courses</li>
                <li className="text-jost-sb-22 completed">Payment DETAILS</li>
                <li className="text-jost-sb-22 active">Confirmation</li>
              </ul>
            </div>
            <div className="new_paid__box_block">
              <div className="new_paid__box__sec1">
                <h2 className="cpay__box__left-txt text-jost-sb-22">
                  Payment Reference #{Math.floor(Math.random() * 1_000_000_000)}
                </h2>

                <div className="new_paid-links">
                  <a
                    href={state?.invoice_file_url}
                    target="_blank"
                    className="res-btn-lightgrn"
                    rel="noreferrer"
                    onClick={handleInvoiceDownload}

                  >
                    Download invoice
                  </a>
                </div>
              </div>
              <div className="new_paid__box__sec2">
                <p className="new_paid__box__sec2-txt text-ops-rg-16">
                  Thank you message. Lorem ipsum dolor sit amet, consectetur
                  adipiscing elit. Proin eu mattis velit. Donec dictum leo vel
                  fermentum placerat. Nulla bibendum blandit. Praesent eu
                  consequat dictum leovel. Aenean consectetur sit amet sem non
                  maximus. Praesent dictum, odio non posuere scelerisque, diam
                  augue sagittis arcu, vitae egestas tortor ligula ut arcu sit
                  amet sem non.
                </p>

                <div className="new_paid__box__sec2-links">
                  <NavLink
                    to="#"
                    target="_self"
                    className="res-btn-primary"
                    onClick={handleSubmit}
                  >
                    Continue
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PayConfirmed;
